/**
 * 機能権限の列挙。後端 Permission.java の enum と 1:1 対応。
 *
 * 仕様書「ユーザーロール」シート（2026-05）の各行に対応する。
 * 権限文字列は後端 PERM_<NAME> Authority と同じキー名を使う。
 *
 * 注：ロール→権限のマトリクスは後端 DB（`role_permissions`）が唯一のソース。
 * 前端は `/api/auth/me` レスポンスの `permissions` 配列で判定する。
 */
export const PERMISSION_KEYS = [
  // ── ホーム（メニュー表示） ──
  'HOME_DATA_IMPORT_MENU',
  'HOME_PAYER_MGMT_MENU',
  'HOME_SYSTEM_MGMT_MENU',
  // ── データ取込 ──
  'DATA_IMPORT_HISTORY_SEARCH',
  'DATA_IMPORT_HISTORY_DOWNLOAD',
  'DATA_IMPORT_HISTORY_DELETE',
  'DATA_IMPORT_CSV',
  'DATA_IMPORT_OCR',
  'DATA_IMPORT_CREATE_RECIPIENT',
  // ── 受給者管理 ──
  'RECIPIENT_SEARCH',
  'RECIPIENT_EXPORT_IDENT_ID',
  'RECIPIENT_EXPORT_PROGRESS_CSV',
  'RECIPIENT_EXPORT_LIST_CSV',
  'RECIPIENT_VIEW',
  'RECIPIENT_EDIT_COMMENT',
  'RECIPIENT_EDIT_NON_COMMENT',
  'RECIPIENT_DELETE',
  'RECIPIENT_IMPORT_BANK_CSV',
  // ── 申出書 ──
  'APPLICATION_CREATE_MANUAL',
  'APPLICATION_VIEW',
  'APPLICATION_EDIT_COMMENT',
  'APPLICATION_EDIT_NON_COMMENT',
  'APPLICATION_REVIEW',
  // ── 支給者管理 ──
  'PAYMENT_LIST_SEARCH',
  'PAYMENT_LIST_CREATE',
  'PAYMENT_LIST_EDIT',
  'PAYMENT_LIST_DELETE',
  'PAYMENT_JOB_CREATE_SEARCH',
  'PAYMENT_JOB_CREATE_COMPLETE',
  'PAYMENT_NOTICE_DOWNLOAD',
  'PAYMENT_EXPORT_ZENGIN',
  'PAYMENT_EXPORT_PAYEE_LIST',
  // ── システム管理 ──
  'USER_MGMT',
  'OPERATION_LOG_VIEW',
  'MUNICIPALITY_MGMT',
  'RELEASE_HISTORY_VIEW',
  'OCR_SUCCESS_STATS_VIEW',
] as const

export type Permission = (typeof PERMISSION_KEYS)[number]

/**
 * ダッシュボード（業務報告 = `/api/dashboard/stats`）を閲覧できる権限集合。
 * 後端 `DashboardController#getStats` の `@PreAuthorize` と 1:1 で同期させる必要がある。
 * いずれか 1 つ持っていれば閲覧可（OR）。
 */
export const DASHBOARD_PERMISSIONS: Permission[] = [
  'HOME_DATA_IMPORT_MENU',
  'HOME_PAYER_MGMT_MENU',
  'HOME_SYSTEM_MGMT_MENU',
  'RECIPIENT_SEARCH',
  'APPLICATION_VIEW',
  'PAYMENT_LIST_SEARCH',
]
